import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Kebab = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z'
          fill='currentColor'
        />
        <path
          d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
          fill='currentColor'
        />
        <path
          d='M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z'
          fill='currentColor'
        />
        <path
          d='M12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M12 4.25C11.0335 4.25 10.25 5.0335 10.25 6C10.25 6.9665 11.0335 7.75 12 7.75C12.9665 7.75 13.75 6.9665 13.75 6C13.75 5.0335 12.9665 4.25 12 4.25Z'
          fill='currentColor'
        />
        <path
          d='M12 10.25C11.0335 10.25 10.25 11.0335 10.25 12C10.25 12.9665 11.0335 13.75 12 13.75C12.9665 13.75 13.75 12.9665 13.75 12C13.75 11.0335 12.9665 10.25 12 10.25Z'
          fill='currentColor'
        />
        <path
          d='M12 16.25C11.0335 16.25 10.25 17.0335 10.25 18C10.25 18.9665 11.0335 19.75 12 19.75C12.9665 19.75 13.75 18.9665 13.75 18C13.75 17.0335 12.9665 16.25 12 16.25Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
